// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xXhn","option":"styles_option__2nqYh","active":"styles_active__3w5lz"};